import React, { useState } from "react";
import { FaIdCard, FaUserCircle, FaVenusMars } from "react-icons/fa";
import ChangePassword from "../Change Password/ChangePassword";
import { RiLockPasswordLine } from "react-icons/ri";
import { LiaUserEditSolid } from "react-icons/lia";
import { selectUser } from "../../redux/authSlice";
import { useSelector } from "react-redux";
import { TbMailFilled } from "react-icons/tb";
import { MdCall } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import { TfiWorld } from "react-icons/tfi";
import UpdateProfileForm from "./UpdateProfileForm";
import { useGetUserQuery } from "../../redux/userApi";

const UpdateProfile = () => {
  const user = useSelector(selectUser);
  const { data } = useGetUserQuery();

  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  return (
    <div className=" flex flex-col gap-3 bg-white rounded-xl xl:p-8 lg:p-6 p-4">
      <div className="rounded-xl w-full shadow-2xl overflow-hidden ">
        <div className="bg-[#04633B1F] flex md:flex-row flex-col md:gap-0 gap-4 items-start justify-between p-4 w-full">
          <div className=" flex items-center gap-3 text-[#00643b] ">
            {user?.profile ? (
              <img
                src={user?.profile}
                className="xl:size-20 lg:size-16 md:size-14 size-16 rounded-full"
                alt=""
              />
            ) : (
              <FaUserCircle className=" xl:size-20 lg:size-16 md:size-14 size-16 " />
            )}

            <div className=" flex flex-col  ">
              <h1 className=" xl:text-[1.8rem] lg:text-[1.4rem] text-[1.2rem] font-bold capitalize">
                {user?.name ? user?.name : "username"}
              </h1>
              <p className=" font-semibold capitalize">
                {" "}
                {user?.role ? user?.role : "role"}
              </p>
            </div>
          </div>
          <div className=" flex lg:flex-row flex-col lg:items-center md:items-end items-start lg:gap-4 gap-3">
            <button
              onClick={() => {
                setIsProfileModalOpen(true);
              }}
              className={`flex items-center gap-2  px-2 py-1  text-sm bg-white w-max rounded-full font-semibold text-[#00643b] border border-[#00643b]`}
            >
              <LiaUserEditSolid className=" size-5 " />
              Edit Profile
            </button>

            <button
              onClick={() => {
                setIsPasswordModalOpen(true);
              }}
              className={`flex items-center gap-2  px-2 py-1  text-sm bg-white w-max rounded-full font-semibold text-[#00643b] border border-[#00643b]`}
            >
              <RiLockPasswordLine className=" size-5 " />
              Change Password
            </button>
          </div>

          <ChangePassword
            isOpen={isPasswordModalOpen}
            setIsOpen={setIsPasswordModalOpen}
          />
          <UpdateProfileForm
            isOpen={isProfileModalOpen}
            setIsOpen={setIsProfileModalOpen}
          />
        </div>
        <div className="grid sm:grid-cols-2 grid-cols-1 gap-8 p-4 text-[#5b5b5e] xl:text-sm text-[12px] ">
          <div className=" flex gap-2 items-center">
            <TbMailFilled className=" xl:size-7 lg:size-6 size-5" />
            <div>
              <p className=" font-bold">Email</p>
              <p>{user?.email ? user?.email : "abcd@gmail.com"}</p>
            </div>
          </div>
          <div className=" flex gap-2 items-center">
            <MdCall className=" xl:size-7 lg:size-6 size-5" />
            <div>
              <p className=" font-bold">Phone</p>
              <p>{user?.phone ? user?.phone : "+923000000000"}</p>
            </div>
          </div>

          <div className=" flex gap-2 items-center">
            <FaIdCard className=" xl:size-7 lg:size-6 size-5" />
            <div>
              <p className=" font-bold">CNIC</p>
              <p>{user?.cnic ? user?.cnic : "33104-1234567-1"}</p>
            </div>
          </div>
          <div className=" flex gap-2 items-center">
            <FaLocationDot className=" xl:size-7 lg:size-6 size-5" />
            <div>
              <p className=" font-bold">Address</p>
              <p>
                {user?.address
                  ? user?.address
                  : "123 Main St, City, State, ZIP"}
              </p>
            </div>
          </div>
          <div className=" flex gap-2 items-center">
            <FaVenusMars className=" xl:size-7 lg:size-6 size-5" />
            <div>
              <p className=" font-bold">Gender</p>
              <p>{user?.gender ? user?.gender : "Gender"}</p>
            </div>
          </div>
          <div className=" flex gap-2 items-center">
            <TfiWorld className=" xl:size-7 lg:size-6 size-5" />
            <div>
              <p className=" font-bold">Country</p>
              <p>Pakistan</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateProfile;
